module.exports = __webpack_public_path__ + "img/古灵男.5bce8b45.png";